import { getCookie, setCookie } from 'react-use-cookie';

import { OAuthApi, OAuthScope } from '@backstage/core-plugin-api';
import jwt_decode, { JwtPayload } from 'jwt-decode';

function get_cached_token(audience: string): { token: string; valid: boolean } {
  const token_cookie = getCookie(`user-${audience}-token`);

  if (!token_cookie) {
    return { token: '', valid: false };
  }
  const decoded = jwt_decode<JwtPayload>(token_cookie);
  if (decoded.exp) {
    const now = Math.floor(Date.now() / 1000);
    if (decoded.exp - now > 60) {
      return { token: token_cookie, valid: true };
    }
  }
  return { token: '', valid: false };
}

export async function getUserAccessToken(
  oauthAPi: OAuthApi,
  audience: string,
  scopes: OAuthScope,
): Promise<string> {
  const token_info = get_cached_token(audience);
  if (token_info.valid) {
    return token_info.token;
  }
  try {
    const apiToken = await oauthAPi.getAccessToken(scopes);
    setCookie(`user-${audience}-token`, apiToken);
    return apiToken;
  } catch (error) {
    await oauthAPi.getAccessToken(['user.read']);
  }
  return '';
}
